import React,{useState,useEffect} from 'react'
import { Header,ElectionCard } from '../components'
import { electionsCandidates } from '../sampleData'
import Swal from 'sweetalert2';

const Nomination = () => {

  useEffect(() => {
    Swal.fire({
      icon: 'info',
      title: 'Nomination',
      text: 'The nominations page is currently unavailable',
    })
  },[])
  return (
    <div className='h-screen mx-1 flex flex-col items-center'>
      <Header pageView='Nomination'/>

     
    </div>
  )
}

export default Nomination